module.exports = __webpack_public_path__ + "img/xz1.9355525e.jpg";